import { Directive, input } from '@angular/core';
import { AdvancedCommerceStore } from '@df/module-advanced-commerce';

@Directive()
export class AdvancedCommerceListingAdvertComponentDef {
    readonly item = input.required<AdvancedCommerceStore.Items.Item>();
}
